module.exports = __webpack_public_path__ + "img/94.eac7298d.png";